import { request as sonataRequest } from 'sonata-react-components';

import type { MetadataAudienceTargeting } from 'sonata-static-storage/lib/common/common.types';
import type { DoohMetricsProfileInterface } from 'sonata-static-storage/lib/schemas/campaign/doohMetricsProfile.schema';

export type DoohAudienceEntity = 'insertionOrder' | 'lineItem';

/**
 * The audience target of a DOOH insertion order / line item: whether its coverage study is generated, its Tesela codes
 * (none: the total population) and how it was set up
 */
export type DoohAudience = Pick<DoohMetricsProfileInterface, 'enableGenerateReport' | 'variables'> &
  MetadataAudienceTargeting;

// The router of each entity in platform-api
const ENTITY_PATHS: Record<DoohAudienceEntity, string> = {
  insertionOrder: 'insertionOrder',
  lineItem: 'lineItems'
};

/** The coverage study catalogue of a country (GET coverageInsightsReport/variables): groups whose leaves are variables */
export type CoverageVariableNode = {
  aggregationType?: string;
  description: string;
  items?: Record<string, CoverageVariableNode>;
};

const getDoohAudienceUrl = (entity: DoohAudienceEntity, userId: string, id: string): string =>
  `${taptap.config.backendUrlBase}multiflight/${ENTITY_PATHS[entity]}/${userId}/${id}/doohAudience`;

export function getDoohAudience(entity: DoohAudienceEntity, userId: string, id: string): Promise<DoohAudience> {
  return sonataRequest.makeRequest(getDoohAudienceUrl(entity, userId, id), { method: 'GET' });
}

/** With a text, the variables are resolved with AI from it: the response holds the ones stored */
export function saveDoohAudience(
  entity: DoohAudienceEntity,
  userId: string,
  id: string,
  { enableGenerateReport, text, variables }: Pick<DoohAudience, 'enableGenerateReport' | 'text' | 'variables'>
): Promise<DoohAudience> {
  return sonataRequest.makeRequest(getDoohAudienceUrl(entity, userId, id), {
    data: { enableGenerateReport, text, variables },
    method: 'PUT'
  });
}

export function getCoverageVariables(country: string): Promise<Record<string, CoverageVariableNode>> {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}coverageInsightsReport/variables`, {
    method: 'GET',
    params: { country }
  });
}
